import React from 'react';
import { Table } from 'react-bootstrap';
import { isArray } from 'lodash';
import { getOrgTermsContent } from '../../content/utils.js';
import styles from './CustomChangeImpactTypesTable.module.css';

const CustomProjectsTableRow = (status, onShowModal, initiativeType, index) => (
  <React.Fragment>
    <tr key={`${status.name}${status.id}`}>
      <td style={{ paddingLeft: '74px', width: '50%' }}>
        <h3>{status.name}</h3>
      </td>
      <td style={{ width: '25%' }}>
        <strong>{status.projectsCount}</strong>
      </td>
      <td style={{ width: '25%' }}>
        <strong>{status.changeImpactsCount}</strong>
      </td>
    </tr>
  </React.Fragment>
);

const CustomChangeImpactTypesTable = ({
  customStatuses,
  onShowModal,
  initiativeType,
}) => (
  <Table hover className={styles.customChangeImpactTypesTable}>
    <thead>
      <tr>
        <th style={{ paddingLeft: '74px' }}>Title</th>
        <th>{getOrgTermsContent('projects')}</th>

        <th>Change Impacts</th>
      </tr>
    </thead>
    <tbody>
      {isArray(customStatuses)
        ? customStatuses
            .sort((a, b) => a.priority - b.priority)
            .map((category, index) =>
              CustomProjectsTableRow(
                category,
                onShowModal,
                initiativeType,
                index
              )
            )
        : null}
    </tbody>
  </Table>
);

export default CustomChangeImpactTypesTable;
